/** @format */

import { Node, mergeAttributes } from '@tiptap/react';

/**
 * Custom callout block node for the rich text editor.
 * Renders as a styled div with a left border accent.
 */
export const CalloutExtension = Node.create({
  name: 'callout',
  group: 'block',
  content: 'inline*',

  addAttributes() {
    return {
      type: {
        default: 'info',
        parseHTML: (element) => element.getAttribute('data-callout-type') ?? 'info',
        renderHTML: (attributes) => ({
          'data-callout-type': attributes.type as string,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-callout]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-callout': '',
        class: 'callout-block border-l-4 border-indigo-400 bg-indigo-50/50 rounded-r-lg p-4 my-3 text-xl',
      }),
      0,
    ];
  },
});
